<template src="./empty.html"></template>
<script>
import genCore from './emptyStatus.js';
export default genCore(true);
</script>

<style lang="scss" src="./empty.scss">
</style>